import { useState, useEffect} from "react";
import { restaurantList } from "../constants";
import RestaurantCard from "./RestaurantCard";
import { GET_RES_API_URL } from "../constants";
import Shimmer from "./Shimmer";
import Empty from "./Empty";
import { filterData } from "../utils/helper";
import useOnline from "../utils/useOnline";
import Offline from "./UserOffline";
import useGetLocation from "../utils/useGetLocation";
import { IoIosSearch } from "react-icons/io";

// let allRestaurants = restaurantList;

const Body = () => {
  const [searchText, setSearchText] = useState("");
  const [filteredRestaurants, setFilteredRestaurants] = useState([]);
  const [allRestaurants, setAllRestaurants] = useState(null);

  const userLocation = useGetLocation();

  useEffect(() => {
    if(userLocation["lat"] && userLocation["lng"]) {
      // console.log("Got user location, now fetching");
      getRestaurants();
    }
  }, [userLocation]);

  const getRestaurants = async () => {
    try {
      const response = await fetch(`${GET_RES_API_URL}lat=${userLocation.lat}&lng=${userLocation.lng}`); //stream of data
      const responseInJson = await response.json(); //readable stream of data
      
      const fetchedRestaurants = (
        responseInJson.data?.cards
          ?.map((x) => x?.card?.card)
          .find(
            (x) =>
              x["@type"] ===
                "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget" &&
              x.gridElements.infoWithStyle["@type"] ===
                "type.googleapis.com/swiggy.presentation.food.v2.FavouriteRestaurantInfoWithStyle"
          )?.gridElements?.infoWithStyle?.restaurants?.map(x => x.info)
      );
        
      // const fetchedOffers =
      //   responseInJson.data?.cards[0].card?.card?.imageGridCards?.info;

      // console.log(fetchedOffers);
      // console.log(fetchedRestaurants);

      setAllRestaurants(fetchedRestaurants);
      setFilteredRestaurants(fetchedRestaurants);

    } catch (error) {
      console.log(error);
    }
  };

  const formSubmitHandler = (e) => {
    e.preventDefault();
    const filteredData = filterData(searchText, allRestaurants);
    setFilteredRestaurants(filteredData);
  }

  const isOnline = useOnline();

  if (!isOnline) {
    return <Offline />;
  }

  // Don't render Component(Early return)
  // if (!allRestaurants) {
  //   return null;
  // }

  return (
    <div className="bg">
      <form
        data-testid="search-box"
        className="flex flex-col w-11/12 sm:w-3/5 rounded-sm sm:flex-row md:w-2/5 my-4 mx-auto border-2 sm:rounded-full"
        onSubmit={formSubmitHandler}
      >
        <input
          data-testid="search-input"
          type="text"
          value={searchText}
          name="keyword"
          className="grow py-2 px-4 focus:outline-0 sm:rounded-l-full"
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          placeholder="Enter Keyword"
        />
        <button
          data-testid="search-btn"
          type="submit"
          className="py-1 px-4 flex justify-center items-center text-2xl sm:rounded-r-full bg-slate-100 hover:scale-105"
        >
          <IoIosSearch />
        </button>
      </form>

      {/* {
        // JS Expression & JS statements

        //JS statement
        //It will not work
        // let a = 5;
        // console.log(a);

        //JS Expression
        //It will work
        // ((a=5),(console.log(a)))

      } */}

      {/* If number of all restaurants are zero then show shimmer effect 
      else show api returned data*/}

      {!allRestaurants ? (
        <Shimmer />
      ) : (
        <div
          data-testid="res-list"
          className="flex flex-col sm:grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:w-3/4 mx-auto"
        >
          {filteredRestaurants?.length === 0 ? (
            <Empty />
          ) : (
            filteredRestaurants.map((restaurant) => (
              // <RestaurantCard
              //   cloudinaryImageId={restaurant.data.cloudinaryImageId}
              //   name={restaurant.data.name}
              //   cuisines={restaurant.data.cuisines}
              //   avgRating={restaurant.data.avgRating}
              //   lastMileTravel={restaurant.data.deliveryTime}
              //   key={restaurant.data.uuid}
              // />
              <RestaurantCard {...restaurant} key={restaurant.id} />
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default Body;
